<template>
  <div v-if="isShowCondition" class="condition">
    <div id="headHeight">
      <div class="close" @click="closePop(0)"><img src="@/assets/images/template/toolbar_close1.png"></div>
      <div class="reportTit">
        <SelectAccount />
        <a v-if="(tabIndex!=-1&&tabIndex!=3)||(typeName!='balance'&&typeName!='')" @click="closePop(1)">订单号查询</a>
      </div>
    </div>
    <div id="itemHeight">
      <!--时间-->
      <div class="item">
        <div class="reportTit"><span>时间：{{ checkTimeTxt }}</span></div>
        <div class="reportTime">
          <ul>
            <li @click="selectStartTime"><p>{{ checkTime.replace(/\//g, '-') }}</p><em /></li>
            <li><p>至</p></li>
            <li @click="selectEndTime"><p>{{ checkEndTime.replace(/\//g, '-') }}</p><em /></li>
          </ul>
        </div>
        <div class="itemList">
          <ul>
            <li v-for="(item,index) in timeList" :class="{checked:timeNum==index}" @click="selectTime(item,index)"><span>{{ item }}</span></li>
          </ul>
        </div>
      </div>
      <!--订单类型-->
      <div v-if="((tabIndex==0||tabIndex==2))||((typeName=='trades'||typeName=='profit')&&typeName!='')" class="item">
        <div class="reportTit"><span>订单类型：<em>{{ checkType=='all'?'所有':checkType }}</em></span></div>
        <div class="itemList">
          <ul>
            <li v-for="(item,index) in orderType" ref="liType" class="item-type" :class="{checked:checkType.includes(item)}" @click="selectType(item,index)"><span>{{ item }}</span></li>
            <li :class="typeNum=='all'?'checked':''" @click="selectType('all','all')"><span>所有</span></li>
          </ul>
        </div>
      </div>
      <!--交易类型-->
      <!-- <div v-if="((tabIndex==0||tabIndex==2))||((typeName=='trades'||typeName=='profit')&&typeName!='')" class="item">
        <div class="reportTit"><span>交易类型：<em>{{ checkTradeType=='all'?'所有':checkTradeType }}</em></span></div>
        <div class="itemList">
          <ul>
            <li
              v-for="(item,index) in tradeList"
              ref="tradeType"
              :key="'trade-list-' + item"
              class="item-type"
              :class="{checked: checkTradeType.includes(item)}"
              :data-value="item"
              @click="selectTradeType(item, index)"
            >
              <span>{{ item }}</span>
            </li>
            <li
              :class="tradeNum === 'all' ? 'checked': ''"
              @click="selectTradeType('all', 'all')"
            >
              <span>所有</span>
            </li>
          </ul>
        </div>
      </div> -->
      <!--状态-->
      <div v-if="(tabIndex==1)||(typeName=='order'&&typeName!='')" class="item">
        <div class="reportTit"><span>状态：<em>{{ checkType=='all'?'所有':checkType }}</em></span></div>
        <div class="itemList">
          <ul>
            <li v-for="(item,index) in orderType" ref="liType" class="item-type" :class="{checked:checkType.split(',').includes(item)}" @click="selectType(item,index)"><span>{{ item }}</span></li>
            <li :class="typeNum=='all'?'checked':''" @click="selectType('all','all')"><span>所有</span></li>
          </ul>
        </div>
      </div>
      <!--项目-->
      <div v-if="(tabIndex==3)||(typeName=='balance'&&typeName!='')" class="item">
        <div class="reportTit"><span>项目：<em>{{ checkType=='all'?'所有':checkType }}</em></span></div>
        <div class="itemList">
          <ul>
            <li v-for="(item,index) in orderType" ref="liType" :key="'check-type-' + index" class="item-type" :class="{checked:checkType.split(',').includes(item)}" @click="selectType(item,index)"><span>{{ item }}</span></li>
            <li :class="typeNum=='all'?'checked':''" @click="selectType('all','all')"><span>所有</span></li>
          </ul>
        </div>
      </div>
      <!--方向-->
      <div v-if="(tabIndex!=-1&&tabIndex!=3)||(typeName!='balance'&&typeName!='')" class="item">
        <div class="reportTit"><span>方向：<em>{{ checkDirection=='all'?'所有':checkDirection }}</em></span></div>
        <div class="itemList">
          <ul>
            <li v-for="(item,index) in direction" ref="liDirection" class="item-direction" :class="{checked:directionNum.includes(index)}" @click="selectDirection(item,index)"><span>{{ item }}</span></li>
            <li :class="directionNum=='all'?'checked':''" @click="selectDirection('all','all')"><span>所有</span></li>
          </ul>
        </div>
      </div>
      <!--交易類型-->
      <!-- <div class="item" v-if="((tabIndex==0||tabIndex==2))||((typeName=='trades'||typeName=='profit')&&typeName!='')"> -->
      <div v-if="((tabIndex==0))||((typeName=='trades')&&typeName!='')" class="item">
        <div class="reportTit">
          <span>交易类型：
            <em>{{ selectedTradeTypes.find(ele => ele.code) === 'all' ? '所有' : selectedTradeTypes.map(ele => ele.text).join(',') }}</em>
          </span>
        </div>
        <div class="itemList">
          <ul>
            <li
              v-for="(item, index) in tradeTypes"
              :key="'trade-selection-' + index"
              ref="liTradeType"
              class="item-type"
              :class="{ checked: selectedTradeTypes.find(ele => ele.code === item.code) }"
              @click="updateSelectedTradeTypes(item)"
            >
              <span>{{ item.text }}</span>
            </li>
            <li
              :class="{ checked: selectedTradeTypes.find(ele => ele.code === 'all') }"
              @click="updateSelectedTradeTypes('all')"
            >
              <span>所有</span>
            </li>
          </ul>
        </div>
      </div>
      <!--交易手数-->
      <!-- <div class="item" v-if="((tabIndex==0||tabIndex==2))||((typeName=='trades'||typeName=='profit')&&typeName!='')"> -->
      <div v-if="((tabIndex==0))||((typeName=='trades')&&typeName!='')" class="item">
        <div class="reportTit">
          <span>
            交易手数: &nbsp;
            <span v-if="volumeVal !== '' || volumeVal !== null">
              <button type="button" @click="updateVolumeVal(Number(volumeVal) - 0.01)">-</button>
              <input v-model="volumeVal" type="number" min="0.00" class="number-input" placeholder="请输入手数">
              <button type="button" @click="updateVolumeVal(Number(volumeVal) + 0.01)">+</button>
            </span>
          </span>
        </div>
        <div class="itemList">
          <ul>
            <li
              v-for="(item, index) in volumeOptions"
              :key="'volume-options-' + index"
              ref="liVolumeOption"
              class="item-type"
              :class="{ checked: Number(volumeVal) === item }"
              @click="updateVolumeVal(item)"
            >
              <span>{{ item }}</span>
            </li>
            <li :class="{ checked: volumeVal <= 0 }" @click="updateVolumeVal(0)">
              <span>所有</span>
            </li>
          </ul>
        </div>
      </div>
      <!--产品-->
      <div v-if="(tabIndex!=-1&&tabIndex!=3)||(typeName!='balance'&&typeName!='')" class="item">
        <div class="reportTit"><span>产品：<em>{{ checkSymbol=='all'?'所有':checkSymbol }}</em></span></div>
        <div class="itemList">
          <ul>
            <li v-for="(item,index) in symbol" ref="liSymbol" class="item-symbol" :class="{checked:symbolNum.includes(index)}" @click="selectSymbol(item,index)"><span>{{ item }}</span></li>
            <li :class="symbolNum=='all'?'checked':''" @click="selectSymbol('all','all')"><span>所有</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div id="btnHeight" class="btn">
      <span @click="submitCondition(0)">重置</span>
      <span @click="submitCondition(1)">确定</span>
    </div>
    <Time v-if="isStartTime" :show="isStartTime" @change="changeStartTime" @cancel="cancelStartTime" />
    <Time v-if="isEndTime" :show="isEndTime" @change="changeEndTime" @cancel="cancelEndTime" />
  </div>
</template>

<script>
import utils from '@/utils/tradeDataUtil'
import Time from '@/view/report/Time.vue'
import { mapState } from 'vuex'
import SelectAccount from '@/view/module/SelectAccount.vue'

export default {
  name: 'ReportCondition',
  components: { Time, SelectAccount },
  props: ['platformName', 'isReportCondition', 'orderType', 'direction', 'symbol', 'dataCondition'],
  computed: {
    ...mapState(['tabIndex', 'platform', 'gts2AccountId']),
    typeNumArr: {
      get() {
        const typeNumData = []
        for (const i in this.orderType) {
          typeNumData.push(i)
        }
        return typeNumData
      }
    },
    directionNumArr: {
      get() {
        const directionNumData = []
        for (const i in this.direction) {
          directionNumData.push(i)
        }
        return directionNumData
      }
    },
    symbolNumArr: {
      get() {
        const symbolNumData = []
        for (const i in this.symbol) {
          symbolNumData.push(i)
        }
        return symbolNumData
      }
    }
  },
  data() {
    return {
      isStartTime: false,
      isEndTime: false,
      typeName: this.$route.query.typeName || '',
      isShowCondition: this.isReportCondition,
      timeNum: this.dataCondition.timeNum,
      checkTime: this.dataCondition.checkTime,
      checkEndTime: this.dataCondition.checkEndTime,
      checkTimeTxt: this.dataCondition.checkTimeTxt,
      checkType: this.dataCondition.checkType,
      checkTradeType: this.dataCondition.checkTradeType,
      typeNum: this.dataCondition.typeNum,
      tradeNum: this.dataCondition.tradeNum,
      checkDirection: this.dataCondition.checkDirection,
      directionNum: this.dataCondition.directionNum,
      checkSymbol: this.dataCondition.checkSymbol,
      symbolNum: this.dataCondition.symbolNum,
      timeList: ['当日', '一周', '一个月', '三个月'],
      tradeTypes: [{
        code: 'OPEN',
        text: '开仓'
      }, {
        code: 'CLOSE',
        text: '平仓'
      }],
      selectedTradeTypes: this.dataCondition.selectedTradeTypes,
      volumeOptions: [0.01, 0.05, 0.10, 0.50, 1.00],
      volumeVal: this.dataCondition.volumeVal ? this.dataCondition.volumeVal : null
    }
  },
  mounted() {
    this.docHeight()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    changeStartTime(data) {
      this.timeNum = -1
      this.checkTime = new Date(data).format('Y-MM-dd')
      this.checkTimeTxt = this.checkTime + '至' + this.checkEndTime
    },
    cancelStartTime(show) {
      this.isStartTime = show
    },
    selectStartTime() {
      this.isStartTime = true
    },
    changeEndTime(data) {
      this.timeNum = -1
      this.checkEndTime = new Date(data).format('Y-MM-dd')
      this.checkTimeTxt = this.checkTime + '至' + this.checkEndTime
    },
    cancelEndTime(show) {
      this.isEndTime = show
    },
    selectEndTime() {
      this.isEndTime = true
    },
    closePop(type) {
      this.isShowCondition = false
      this.$emit('changeConditionPop', this.isShowCondition)
      if (type == 0) {
        this.toggleFixed()
      } else {
        this.$emit('changeBlushPop', !this.isShowCondition)
      }
    },
    docHeight() {
      const clientHeight = window.innerHeight || document.documentElement.clientHeight
      const itemHeight = document.getElementById('itemHeight')
      const headHeight = document.getElementById('headHeight').clientHeight
      const btnHeight = document.getElementById('btnHeight').clientHeight
      itemHeight.style.maxHeight = (clientHeight - (headHeight + btnHeight)) + 'px'
    },
    selectTime(time, index) {
      this.timeNum = index
      if (time == '当日') {
        this.checkTime = new Date().format('Y-MM-dd')
      } else if (time == '一周') {
        this.checkTime = utils.getDay(-6)
      } else if (time == '一个月') {
        this.checkTime = utils.getLast1Month(new Date()).beginTime
      } else if (time == '三个月') {
        this.checkTime = utils.getLast3Month(new Date()).beginTime
      }
      this.checkEndTime = new Date().format('Y-MM-dd')
      this.checkTimeTxt = time
    },
    updateSelectedTradeTypes(type) {
      if (type === 'all') {
        this.selectedTradeTypes = [{ code: 'all', text: '所有' }]
        // this.selectedTradeTypes = []
        // this.selectedTradeTypes.push({ code: 'all', text: '所有' })
        return
      }
      if (type.code !== 'all') {
        const idx = this.selectedTradeTypes.findIndex(ele => ele.code === 'all')
        if (idx !== -1) {
          this.selectedTradeTypes.splice(idx, 1)
        }
      }
      const idx = this.selectedTradeTypes.findIndex(ele => ele.code === type.code)
      if (idx !== -1) {
        this.selectedTradeTypes.splice(idx, 1)
      } else {
        this.selectedTradeTypes.push(type)
      }
      if (this.selectedTradeTypes.length <= 0) {
        this.selectedTradeTypes.push({ code: 'all', text: '所有' })
      }
    },
    selectType(type, index) {
      const indx = this.typeNumArr.indexOf(index)
      if (index == 'all') {
        for (const i in this.typeNumArr) {
          document.querySelectorAll('.item-type')[i].classList.remove('checked')
        }
        this.checkType = 'all'
        this.typeNum = 'all'
      } else {
        const newCheckTypeArr = this.checkType.split(',').filter(e => e !== 'all')
        const newTypeNumArr = this.typeNum.split(',').filter(e => e !== 'all')
        const entry = Object.entries(this.orderType).find(([key, _]) => key === index)
        if (Array.isArray(entry)) {
          const [key, name] = entry
          const i = newCheckTypeArr.findIndex(e => e === name)
          const j = newTypeNumArr.findIndex(e => e === key)
          if (i === -1) {
            newCheckTypeArr.push(name)
          } else {
            newCheckTypeArr.splice(i, 1)
          }
          if (j === -1) {
            newTypeNumArr.push(key)
          } else {
            newTypeNumArr.splice(j, 1)
          }
        }
        this.checkType = newCheckTypeArr.length === 0 ? 'all' : newCheckTypeArr.join(',')
        this.typeNum = newTypeNumArr.length === 0 ? 'all' : newTypeNumArr.join(',')
      }
    },
    selectDirection(direction, index) {
      if (index == 'all') {
        this.directionNum = index
        this.checkDirection = 'all'
      } else {
        const newTextArr = this.checkDirection.split(',').filter(e => e !== 'all')
        const newKeyArr = this.directionNum.split(',').filter(e => e !== 'all')
        const entry = Object.entries(this.direction).find(([key, _]) => key === index)
        if (Array.isArray(entry)) {
          const [key, name] = entry
          const i = newTextArr.findIndex(e => e === name)
          const j = newKeyArr.findIndex(e => e === key)
          if (i === -1) {
            newTextArr.push(name)
          } else {
            newTextArr.splice(i, 1)
          }
          if (j === -1) {
            newKeyArr.push(key)
          } else {
            newKeyArr.splice(j, 1)
          }
        }
        this.checkDirection = newTextArr.length === 0 ? 'all' : newTextArr.join(',')
        this.directionNum = newKeyArr.length === 0 ? 'all' : newKeyArr.join(',')
      }
    },
    selectTradeType(type, index) {
      if (index === 'all') {
        // for (const ele in this.$refs.tradeType) {
        //   this.$refs.tradeType[ele].classList.remove('checked')
        // }
        this.tradeNum = index
        this.checkTradeType = 'all'
      } else {
        const newTextArr = this.checkTradeType.split(',').filter(e => e !== 'all')
        const newKeyArr = this.tradeNum.split(',').filter(e => e !== 'all')
        const entry = Object.entries(this.tradeTypes).find(([key, _]) => key === index)
        if (Array.isArray(entry)) {
          const [key, name] = entry
          const i = newTextArr.findIndex(e => e === name)
          const j = newKeyArr.findIndex(e => e === key)
          if (i === -1) {
            newTextArr.push(name)
          } else {
            newTextArr.splice(i, 1)
          }
          if (j === -1) {
            newKeyArr.push(key)
          } else {
            newKeyArr.splice(j, 1)
          }
        }
        this.checkTradeType = newTextArr.length === 0 ? 'all' : newTextArr.join(',')
        this.tradeNum = newKeyArr.length === 0 ? 'all' : newKeyArr.join(',')
        // this.$refs.tradeType[index].classList.toggle('checked')
        // var selected = this.$refs.tradeType.map(ele => {
        //   if (ele.className.match('checked')) return ele.dataset.value
        //   else return ''
        // }).filter(ele => ele !== '')
        // this.checkTradeType = selected.join(',')
        // this.tradeNum = selected.map(ele => ele === '开仓' ? 'open' : 'close').join(',')
      }
    },
    selectSymbol(symbol, index) {
      const indx = this.symbolNumArr.indexOf(index)
      if (index == 'all') {
        // for (const i in this.symbolNumArr) {
        //   document.querySelectorAll('.item-symbol')[i].classList.remove('checked')
        // }
        this.symbolNum = index
        this.checkSymbol = 'all'
      } else {
        const newTextArr = this.checkSymbol.split(',').filter(e => e !== 'all')
        const newKeyArr = this.symbolNum.split(',').filter(e => e !== 'all')
        const entry = Object.entries(this.symbol).find(([key, _]) => key === index)
        if (Array.isArray(entry)) {
          const [key, name] = entry
          const i = newTextArr.findIndex(e => e === name)
          const j = newKeyArr.findIndex(e => e === key)
          if (i === -1) {
            newTextArr.push(name)
          } else {
            newTextArr.splice(i, 1)
          }
          if (j === -1) {
            newKeyArr.push(key)
          } else {
            newKeyArr.splice(j, 1)
          }
        }
        this.checkSymbol = newTextArr.length === 0 ? 'all' : newTextArr.join(',')
        this.symbolNum = newKeyArr.length === 0 ? 'all' : newKeyArr.join(',')
        // if (this.$refs.liSymbol[indx].className == 'item-symbol') {
        //   this.$refs.liSymbol[indx].className = 'item-symbol checked'
        // } else {
        //   this.$refs.liSymbol[indx].className = 'item-symbol'
        // }
        // const checkedArr = []; const checkedId = []
        // for (const j in document.querySelectorAll('.item-symbol.checked')) {
        //   if (!isNaN(j)) {
        //     const name = document.querySelectorAll('.item-symbol.checked')[j].childNodes[0].innerText
        //     checkedArr.push(name)
        //     for (const k in this.symbol) {
        //       if (this.symbol[k] == name) {
        //         checkedId.push(k)
        //       }
        //     }
        //   }
        // }
        // this.checkSymbol = checkedArr.join(',')
        // this.symbolNum = checkedId.join(',')
      }
    },
    updateVolumeVal(val) {
      if (val <= 0 || val === null) return this.volumeVal = null
      this.volumeVal = val.toFixed(2)
    },
    submitCondition(id) {
      // @param:
      // id === 0 重置
      // id === 1 提交
      let data, options
      if (id == 0) {
        this.timeNum = 2
        this.checkTime = utils.getLast1Month(new Date()).beginTime
        this.checkEndTime = utils.getLast1Month(new Date()).endTime
        this.checkTimeTxt = '一个月'
        this.checkType = 'all'
        this.typeNum = 'all'
        this.checkDirection = 'all'
        this.checkTradeType = 'all'
        this.directionNum = 'all'
        this.checkSymbol = 'all'
        this.symbolNum = 'all'
        this.selectedTradeTypes = [{ code: 'all', text: '所有' }]
        this.volumeVal = null
        const options = {
          timeNum: this.timeNum,
          checkTime: this.checkTime,
          checkEndTime: this.checkEndTime,
          checkTimeTxt: this.checkTimeTxt,
          checkType: this.checkType,
          checkTradeType: this.checkTradeType,
          typeNum: this.typeNum,
          tradeNum: this.tradeNum,
          checkDirection: this.checkDirection,
          directionNum: this.directionNum,
          checkSymbol: this.checkSymbol,
          symbolNum: this.symbolNum,
          selectedTradeTypes: this.selectedTradeTypes,
          volumeVal: null
        }
        if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) this.$store.dispatch('setTradeCondition', options)
        if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.$store.dispatch('setEntrustCondition', options)
        if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) this.$store.dispatch('setProfitAndLossCondition', options)
        if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.$store.dispatch('setCreditCondition', options)
        if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) this.$store.dispatch('setStopCondition', options)
      } else if (id == 1) {
        this.toggleFixed()
        options = {
          timeNum: this.timeNum,
          checkTime: this.checkTime,
          checkEndTime: this.checkEndTime,
          checkTimeTxt: this.checkTimeTxt,
          checkType: this.checkType,
          checkTradeType: this.checkTradeType,
          tradeNum: this.tradeNum,
          typeNum: this.typeNum,
          checkDirection: this.checkDirection,
          directionNum: this.directionNum,
          checkSymbol: this.checkSymbol,
          symbolNum: this.symbolNum,
          selectedTradeTypes: this.selectedTradeTypes,
          volumeVal: this.volumeVal
        }
        if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) {
          data = {
            index: 1,
            pageSize: 10,
            beginTime: this.checkTime,
            endTime: this.checkEndTime,
            symbol: this.symbolNum == 'all' ? '' : this.symbolNum,
            orderType: this.typeNum == 'all' ? '' : this.typeNum,
            direction: this.directionNum == 'all' ? '' : this.directionNum,
            platform: this.platform
            // reportType: this.selectedTradeTypes.length >= 2 ? '' : this.selectedTradeTypes.map(ele => ele.code).join(','),
            // execvolume: Number(this.volumeVal) > 0 ? Number(this.volumeVal) : ''
          }
          if (this.volumeVal > 0 && this.volumeVal !== null) data.execvolume = Number(this.volumeVal)
          if (this.selectedTradeTypes.findIndex(ele => ele.code === 'all') === -1) data.reportType = this.selectedTradeTypes.map(ele => ele.code).join(',')
        } else if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) {
          data = {
            index: 1,
            pageSize: 10,
            beginTime: this.checkTime,
            endTime: this.checkEndTime,
            symbol: this.symbolNum == 'all' ? '' : this.symbolNum,
            status: this.typeNum == 'all' ? '' : this.typeNum,
            direction: this.directionNum == 'all' ? '' : this.directionNum,
            gts2AccountId: this.gts2AccountId,
            platform: this.platform
          }
        } else if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) {
          data = {
            index: 1,
            pageSize: 10,
            beginTime: this.checkTime,
            endTime: this.checkEndTime,
            symbol: this.symbolNum == 'all' ? '' : this.symbolNum,
            orderType: this.typeNum == 'all' ? '' : this.typeNum,
            openDirection: this.directionNum == 'all' ? '' : this.directionNum,
            platform: this.platform
            // reportType: this.selectedTradeTypes.length >= 2 ? '' : this.selectedTradeTypes.map(ele => ele.code).join(','),
            // execvolume: Number(this.volumeVal) > 0 ? Number(this.volumeVal) : ''
          }
          // if (this.volumeVal > 0 && this.volumeVal !== null) data.execvolume = Number(this.volumeVal)
          // if (this.selectedTradeTypes.findIndex(ele => ele.code === 'all') === -1) data.reportType = this.selectedTradeTypes.map(ele => ele.code).join(',')
        } else if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) {
          data = {
            index: 1,
            pageSize: 10,
            beginTime: this.checkTime,
            endTime: this.checkEndTime,
            reportType: this.typeNum == 'all' ? '' : this.typeNum,
            gts2AccountId: this.gts2AccountId,
            platform: this.platform
          }
        } else if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) {
          data = {
            index: 1,
            pageSize: 10,
            beginTime: this.checkTime,
            endTime: this.checkEndTime,
            reportType: this.typeNum == 'all' ? '' : this.typeNum,
            gts2AccountId: this.gts2AccountId,
            platform: this.platform
          }
        }
        if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) this.$store.dispatch('setTradeCondition', options)
        if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.$store.dispatch('setEntrustCondition', options)
        if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) this.$store.dispatch('setProfitAndLossCondition', options)
        if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.$store.dispatch('setCreditCondition', options)
        if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) this.$store.dispatch('setStopCondition', options)
        this.$emit('report', data)
        this.isShowCondition = false
        this.$emit('changeConditionPop', this.isShowCondition)
      }
    }
  }
}
</script>
